// @ts-nocheck

import { request } from '../../../context';
import type { ApiOptions } from '../../../context';
import type { BaseResponse } from '../../../types';

export interface GetDataByIdEditableParam {
    /** id */
    id: number;
}

/**
 * 查询是否可编辑
 *
 * @export
 * @tags 通对话管理
 * @link [GET] /data/{id}/editable
 * @param id
 */
export function getDataByIdEditable(
    options: ApiOptions<GetDataByIdEditableParam, never> & { segments: GetDataByIdEditableParam }
): Promise<BaseResponse> {
    return request<never, GetDataByIdEditableParam, never>('/data/{id}/editable', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getDataByIdEditable',
    });
}

export const meta = [{ tags: ['通对话管理'], path: '/data/{id}/editable', method: 'get' }];
